import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  color: #333;
  padding: 0 10px;

  span {
    margin-right: 7px;
  }
`;
